import {
  minValue,
  minLength,
  maxLength,
  required,
  numeric
} from 'vuelidate/lib/validators';

export default {
  payload: {
    accountName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(20)
    },
    bsb: {
      required,
      numeric,
      minValue: minValue(0),
      minLength: minLength(6),
      maxLength: maxLength(6)
    },
    accountNumber: {
      required,
      numeric,
      minValue: minValue(0),
      minLength: minLength(6),
      maxLength: maxLength(10)
    }
  }
};
